import React from 'react'

const MiniLogoIcon = () => {
	return (
		<svg width={54} height={54} viewBox='0 0 54 54' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M27 54c14.912 0 27-12.088 27-27S41.912 0 27 0 0 12.088 0 27s12.088 27 27 27z'
				fill='#FF4856'
			/>
			<path
				d='M20.394 12.105c-.837 0-2.232.423-3.906.423-3.024 0-3.186-.648-3.186-.648 0-.225.783-.783 1.116-.783.084-.009.168-.009.252 0 .444.13.905.196 1.368.198 3.906 0 7.038-2.43 9.801-2.43 2.35 0 3.186 1.035 3.186 2.511 0 3.213-4.023 8.523-5.283 9.9a.108.108 0 00.108.108c.666 0 9.774-10.44 12.114-11.556.366-.186.768-.29 1.179-.306a1.63 1.63 0 011.368.639 6.11 6.11 0 011.701 3.6 2.844 2.844 0 01-.477 1.539c-1.008 1.53-4.158 6.11-4.158 6.732 0 0 0 .054.054.054.333 0 1.26-1.008 1.26-1.008.216-.306 6.363-5.4 8.595-5.4a1.332 1.332 0 011.179 1.395 1.08 1.08 0 01-.28.783c-1.62 1.926-7.154 12.033-7.154 16.785a2.232 2.232 0 002.205 2.232 5.4 5.4 0 004.5-3.825s.225-.306.387-.306.396.531.396.783c0 2.403-6.624 11.61-13.878 11.61-2.457 0-4.194-1.368-4.194-4.329 0-2.061.9-4.914 2.88-8.622 0 0 2.79-5.31 2.871-5.895 0-.108-.054-.198-.135-.198a.98.98 0 00-.53.279c-.145.225-4.636 5.949-6.085 7.038a4.5 4.5 0 01-2.88.981c-2.403 0-6.147-.9-6.147-2.097.017-.305.127-.597.315-.837.837-1.143 4.24-5.697 4.24-5.697 0-.306-.001-.531-.109-.531s-.117 0-.198.117c-.36.36-6.642 7.002-7.82 7.677a7.255 7.255 0 01-3.214.9c-2.565 0-6.003-2.88-6.003-5.085 0-.189.144-.531 1.062-.999 5.4-2.907 14.3-11.817 14.3-15.057-.044-.504-.323-.675-.8-.675z'
				fill='#082DE8'
			/>
		</svg>
	)
}

export default MiniLogoIcon
